import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { DownloadFileUtilityService } from 'src/app/service/download-file-utility.service';
import { Draggablemodal1Component } from '../draggablemodal1/draggablemodal1.component';
import * as environmentUrl from 'src/environments/environment';
import { RpcClientService } from 'src/app/service/rpc-client.service';

@Component({
  selector: 'app-vehicle-sessions',
  templateUrl: './vehicle-sessions.component.html',
  styleUrls: ['./vehicle-sessions.component.scss']
})
export class VehicleSessionsComponent implements OnInit {
  ptsUrl = environmentUrl.environment.ptsUrl
  config: any = {
    itemsPerPage: 3,
    currentPage: 1,
    totalItems: 60
  }
  config1: any = {
    itemsPerPage: 3,
    currentPage: 1,
    totalItems: 60
  }
  config2: any = {
    itemsPerPage: 3,
    currentPage: 1,
    totalItems: 60
  }
  page: any
  q: any
  page1: any
  q1: any;
  q2: any
  public indcount = 0;
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public responsive: boolean = true;
  public firstnumber: any;
  public secondnumber: any;
  sessionSource: any
  public fixednum: any;
  public indcount1 = 0;
  public totalSize: number = 0;
  public maxSize1: number = 7;
  translateText = ['Close', 'Print', 'Vehicle Sessions', 'helpText1', 'The', 'Dates', 'helpText2', 'Start Time', 'helpText3', 'Dealer Code', 'helpText4', 'Technician', 'helpText5', 'State column', 'helpText6', 'helpText7', 'The field is empty', 'This means it can be any of', 'Automatically indicted by IDS', 'Hotline indictment', 'TechnicianMechanic indictment', 'Automatically indicted by IDS but the VCM was disconnected during the session', 'Automatically indicted by IDS but the VMM was disconnected during the session', 'In which the RVC for the session is empty.', 'In the instance of RVC(T), a potential RVC output of RVC=0 will not be shown on the screen.', 'A 13 character string beginning with an', 'This is showing you the RVC that was generated for this session.', 'No RVC required', 'This is showing you that the indictment was an RVC(A) and for the repair to be completed', 'Labour', 'This is showing you that the indictment was an RVC(T) for a labor only operation.', 'Major assembly', 'helpText8', 'No RVC available', 'This indicates an error in that the method of indictment has not been seen before and should be investigated.', 'Method', 'column shows the method in which the session indictment occurred. Use the table below to understand what it is showing you and why.', 'The session was automatically indicted by the IDS system.', 'The session was indicted by using the Hotline for indictment approval.', 'The session was manually indicted by the technicianmechanic.', 'The session was automatically indicted by the IDS system and no RVC is required.', 'The session was automatically indicted by the IDS system but the VCM was disconnected from the vehicle during the session.', 'The session was automatically indicted by the IDS system but the VMM was disconnected or not connected to the system during the session when it was needed.', 'RVC(A, No VCM)', 'RVC(A, No VMM)']
  translatedText: any = []
  public directionLinks1: boolean = true;
  public autoHide1: boolean = false;
  public responsive1: boolean = true;
  public firstnumber1: any;
  public secondnumber1: any;
  public fixednum1: any;
  public firstnumber2: any;
  public secondnumber2: any;
  public fixednum2: any;
  public directionLinks2: boolean = true;
  public autoHide2: boolean = false;
  public responsive2: boolean = true;
  public indcount2 = 0;
  public serviceListInprogress: any = [];
  noServiceInprogressData = false
  public vinNumber: any;
  public userName: any;
  public userType: any;
  public serviceList: any = [];
  public centralList: any = [];
  public userId: any;
  public stateList: any;
  public webPages: any;
  public resumeData: any;
  public isAdmin = false;
  public globalManagedRes: any;
  public globalServices: any = [];
  public isEnableService = false;
  targetEngineServiceResponseObj: any
  idsFdspEngineServiceResponseObj: any
  ptsEngineServiceResponseObj: any
  fdspEngineServiceResponseObj: any
  rvcCode: any;
  showloader = true
  showCSDloader: boolean = false;
  noServiceData = false
  noCentralData = false
  tokenDetails: any
  vinDetail: any
  tokenDet: any
  countryCode: string = '';
  NoRVCText = 'RVC Not Required';
  cotactHDesk_text = 'Contact Helpdesk';
  public isFDRSConnected = false;
  tempDealerCode: string = 'null';
  public state: any = {
    "1": "Qualifying vehicle",
    "2": "Viewing diagnostic summary",
    "19": "Running diagnostic",
    "30": "Service Reception closed",
    "5": "Selecting symptoms",
    "4": "Loading diagnostic candidates",
    "6": "Viewing diagnostic candidates",
    "7": "Running SPA diagnostic",
    "8": "Viewing Etis diagnostic page",
    "100": "Processing repair and post repair instructions",
    "20": "Entering Warranty Dealer code",
    "22": "Requesting technical hotline check",
    "60": "Entering hotline repair validation code",
    "21": "Displaying repair validation code",
    "10": "Viewing repair instructions",
    "11": "Running SPA repair instruction",
    "341": "Running OTX repair instruction",
    "12": "Viewing FordETIS repair instruction",
    "14": "Viewing post repair instructions",
    "15": "Running SPA post repair instruction",
    "16": "Viewing FordETIS post repair instruction",
    "221": "Running OTX post repair instruction",
    "18": "Repair completed",
    "401": "Repair Qualification",
    "421": "Running OTX diagnostic candidate",
    "40": "Displaying toolbox menu",
    "80": "Toolbox invoked",
    "3": "Running toolbox",
    "17": "Manual diagnosis",
    "441": "Assistance Needed",
    "551": "Assistance Needed",
      "25":"Entering RVC Code"
  }
  public pageList: any = {
    "diagnosisSymptomSelectionWebPage": "symptoms",
    "networkTestWebPage": "networkTest",
    "symptomEvaluationUserWaitTask": "info",
    "symptomEvaluationUserWaitTaskComplete": "info",
    "manualDiagnosisInstructionsWebPage": "identifyFailure",
    "warrantyDealerCodeSelectionPage": "warrantyDealerCode",
    "repairAndPostRepairEvaluationUserWaitTaskComplete": "repair",
    "repairValidationCodeDisplayWebPage": "repair",
    "repairCandidateSelectionWebPage": "repairProcedures",
    "postRepairCandidateSelectionWebPage": "postrepairProcedures",
    "purchaseRepairWebPage": "view",
    "purchasePostRepairWebPage": "view",
    "purchaseDiagnosticWebPage": "diagnostic-view",
    "rvcWebPage":"identifyFailure"
  }
  @ViewChild('noRVCMsgDesc') noRVCMsgDesc: ElementRef<any>;
   @ViewChild('mobileVanModal') mobileVanModal: ElementRef<any>;
  isButtonEnabled : boolean = true;
  repairData : any;
  constructor(private modalService: NgbModal, private service: ApifirstService, public translate: TranslateService, private downloadFileUtilityService: DownloadFileUtilityService, private router: Router, private rpcClient: RpcClientService) { }

  ngOnInit(): void {
    this.service.tempDealerCode.subscribe((data)=> {
      this.tempDealerCode = data;
      console.log('TEMP DEALER CODE:', this.tempDealerCode)
    })
    localStorage.setItem("component", '');
    localStorage.setItem("manualDiagBtnClick", " ")
    this.rpcClient.checkFDRSConnectionStatus();
    this.getTranslations();
    this.getTargetEngineVersion();
    this.showloader = true
    this.service.vehicleDetails.subscribe((data) => {
      this.vinDetail = data
    })
    this.service.rapToken.subscribe((data) => {
      this.tokenDet = data;
    })
    this.service.serviceNameListservice.subscribe((data) => {
      this.sessionSource = "ALL"
      this.globalServices = data
      for (let obj of this.globalServices) {
        if (obj.serviceName == "IDSFeedback service") {
          this.idsFdspEngineServiceResponseObj = obj;
        }
      }
    })
    this.service.showSBDAdminTab.subscribe((data) => {
      this.isAdmin = data
    })
    this.service.tokenObj.subscribe((data) => {
      this.tokenDetails = data
      let c: any = data
      localStorage.setItem("tokenObj", JSON.stringify(data));
      this.vinNumber = c.vin
      this.userName = c.username
      this.countryCode = c.countryThree;
      this.userType = c.userType;
    })

    this.service.getGlobalManagedServicesDetails(this.idsFdspEngineServiceResponseObj.id).subscribe((data) => {
      this.globalManagedRes = data;
      if (!this.globalManagedRes) {
        this.isEnableService = true;
      } else {
        this.isEnableService = false;
      }
      if (!this.isEnableService) {
        this.service.selectedGlobalServices.next('IDS Feedback Service')
        this.router.navigate(['/globalServiceEnabled']);
      }
      else {
        this.service.getListOfState().subscribe(data => {
          this.stateList = data;
        })
        this.service.userId.subscribe((data) => {
          this.userId = data
          if (this.userId != "") {
            const req = {
              "vin": this.vinNumber,
              "userid": this.userId,
              "pageNumber": 0,
              "pageSize": 20,
              "sessionSource": this.sessionSource
            }

            this.getVehicleSessions(req);
          }
          this.webPageMapping();
        })
      }
    });
    this.service.otxStateChangeObj.next([{}]);
    //this.webPageMapping();
    this.service.isFDRSConnection.subscribe((data) => {
      this.isFDRSConnected = data;
    })

    this.config = {
      itemsPerPage: 20,
      currentPage: 1,
      totalItems: this.serviceList.length
    };
    this.config1 = {
      itemsPerPage: 20,
      currentPage: 1,
      totalItems: this.centralList.length
    }
    this.config2 = {
      itemsPerPage: 20,
      currentPage: 1,
      totalItems: this.serviceListInprogress.length
    }
    this.firstnumber = 1;
    this.secondnumber = this.config.itemsPerPage;
    this.fixednum = this.secondnumber - this.firstnumber;
    this.firstnumber1 = 1;
    this.secondnumber1 = this.config1.itemsPerPage;
    this.fixednum1 = this.secondnumber1 - this.firstnumber1;
    this.firstnumber2 = 1;
    this.secondnumber2 = this.config2.itemsPerPage;
    this.fixednum2 = this.secondnumber2 - this.firstnumber2;
  }
  getVehicleSessions(req: any, refresh?: boolean, filter?: boolean): void {
    this.showCSDloader = true;
    this.service.getVehicleSessionsV1(req).subscribe((datas) => {
      if (datas != null || datas != undefined || datas != "") {
        this.showloader = false
      }
      this.service.sessionData.next(datas.idssessionList);
      let idsData: any = datas.idssessionList;
      if([null,'null',undefined,'undefined',NaN,'NaN'].indexOf(idsData) === -1)
      this.showCSDloader = false;
      if (!refresh) {
        let data: any = datas.sbdoLocalSessionList;
        console.log(data, "Your data is entered")
        console.log(datas, "initial data")
        for (let i of data) {
          let date = new Date(i.createTimeStamp)
          let dateDisplay: any = (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear().toString().substr(2, 2);
          var time = date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true,timeZone:'GMT' })
          i.time = time
          i.date = dateDisplay
          let value = this.stateList[i.workflowSessionState]
          if (this.state[value] != undefined) {
            i.state = this.translate.instant(this.state[value])
          }

          i.mobileVan = i.mobileVehicle ? 'Yes' : 'No';
          i.isMobileVehicle = !!i.mobileVehicle;


        }
        for (let i of data) {
          if (i.workflowSessionState === "sbd.session.state.diagnostic.reception.closed") {
            this.serviceListInprogress.push(i)
          }
          else {
            this.serviceList.push(i)
          }
        }
        if (this.serviceListInprogress == null || this.serviceListInprogress == undefined || this.serviceListInprogress == "") {
          this.noServiceInprogressData = true
        }
        else {
          this.noServiceInprogressData = false
        }

        if (this.serviceList == null || this.serviceList == undefined || this.serviceList == "") {
          this.noServiceData = true
        }
        else {
          this.noServiceData = false
        }
      }
      this.setIDSSessionData(idsData, datas, filter);

      this.indcount = this.serviceList.length
      this.indcount2 = this.serviceListInprogress.length
      console.log(this.serviceList, "service list")
      console.log(this.centralList, "centralList")


    })
  }

  setIDSSessionData(idsData: any[], response: any, filter?: boolean): void {
    if (filter)
      this.q1 = 0;
    for (let i of idsData) {
      let date = new Date(i.createTimeStamp)
      let dateDisplay: any = (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear().toString().substr(2, 2);
      var time = date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true,timeZone:'GMT' })
      i.time = time
      i.date = dateDisplay
      //let value=this.stateList[i.workflowSessionState]
      if (i.workflowSessionState !== 0 && i.workflowSessionState !== undefined) {
        i.state = this.translate.instant(this.state[i.workflowSessionState])
      }
    }
    this.centralList = idsData;
    if (this.centralList == null || this.centralList == undefined || this.centralList == "") {
      this.noCentralData = true
    }
    else {
      this.noCentralData = false
    }
    this.indcount1 = response.totalElements;
    this.totalSize = response.totalElements;
    for (let i of this.centralList) {
      this.rvcCode = ""
      if (i.rvcCode != null) {
        this.rvcCode = i.rvcCode;
      }

      if (i.indictmentMethod != null) {
        if (i.indictmentMethod == "manualTechnician") {
          if (i.rvcCode == "RVC=0") {
            this.rvcCode = "";
            if (i.finisCode == "1111111") {
              this.rvcCode = "Labor"
            }
            else if (i.finisCode == "9999999") {
              this.rvcCode = "Major assembly"
            }
          } else if((i.rvcCode.toUpperCase() == this.NoRVCText.toUpperCase())) {
              this.rvcCode = 'No RVC Required';
          } else if(i.rvcCode.toUpperCase() == this.cotactHDesk_text.toUpperCase() ) {
              this.rvcCode = 'Contact_Helpdesk'
          }
        } else if(i.indictmentMethod == "automatic") {
          if(i.rvcCode.toUpperCase() == this.NoRVCText.toUpperCase()) {
            this.rvcCode = 'No RVC Required';
          } else if(i.rvcCode.toUpperCase() == this.cotactHDesk_text.toUpperCase()) {
            this.rvcCode = 'Contact_Helpdesk'
          }
        }
      }
      i.rvcCodeNew = this.rvcCode;
    }
  }
  getTranslations() {
    for (let item of this.translateText) {
      this.translate.get(item).subscribe((text) => {
        this.translatedText.push(text)
      });
    }
  }

  getTargetEngineVersion() {
    this.service.getTargetEngineVersion().subscribe(
      (data) => {
        localStorage.setItem("Target Engine Version", data.targetingEngineVersion)
      })
  }

  pageChanged(event: any) {

    this.firstnumber = 0;
    this.secondnumber = 0;
    this.config.currentPage = event;
    this.firstnumber = event + (this.fixednum * (event - 1))
    this.secondnumber = event * this.config.itemsPerPage;
    if (this.secondnumber >= this.serviceList.length) {
      this.secondnumber = this.serviceList.length;
    }
  }
  pageChanged1(event: any) {
    console.log(this.q1, event, 'Page change');
    this.firstnumber1 = 0;
    this.secondnumber1 = 0;
    this.config1.currentPage = event;
    this.firstnumber1 = event + (this.fixednum1 * (event - 1))
    this.secondnumber1 = event * this.config1.itemsPerPage;
    if (this.secondnumber1 >= this.totalSize) {
      this.secondnumber1 = this.totalSize;
    }
    let req: any = {
      "vin": this.vinNumber,
      "userid": this.userId,
      "pageNumber": +event - 1,
      "pageSize": 20,
      "sessionSource": this.sessionSource
    }
    this.getVehicleSessions(req, true);
  }
  pageChanged2(event: any) {
    this.firstnumber2 = 0;
    this.secondnumber2 = 0;
    this.config1.currentPage = event;
    this.firstnumber2 = event + (this.fixednum2 * (event - 1))
    this.secondnumber2 = event * this.config1.itemsPerPage;
    if (this.secondnumber2 >= this.serviceListInprogress.length) {
      this.secondnumber2 = this.serviceListInprogress.length;
    }
  }

  downloadSession(createTimeStamp: any, sessionSource: any) {
    const req = {
      "createdTimeStamp": createTimeStamp,
      "vin": this.vinNumber,
      "sessionSource": sessionSource

    }
    console.log(req, "request")
    this.service.getGlobalManagedServicesDetails(this.idsFdspEngineServiceResponseObj.id).subscribe((data) => {
      this.globalManagedRes = data;
      if (!this.globalManagedRes) {
        this.isEnableService = true;
      } else {
        this.isEnableService = false;
      }

      if (this.isEnableService) {
        this.service.getViewSessions(req, this.userName, this.userType).subscribe((data: any) => {
          this.xmlData = data
          var encodedString = btoa(unescape(encodeURIComponent(this.xmlData)));
          this.downloadFileUtilityService.downloadFile(encodedString, 'text/xml', this.vinNumber + ".xml");
          console.log("xmldta", this.xmlData, "encoded", encodedString)
        })

      } else {
        this.service.selectedGlobalServices.next('IDS Feedback Service')
        this.router.navigate(['/globalServiceEnabled']);
      }
    });

    // this.downloadFileUtilityService.downloadFile('1dc379fa4a871075c50742d3c96c4374','application/xml','Diagnostic');
  }
  xmlData: any
  viewSession(createTimeStamp: any, sessionSource: any, fromCentralStore: boolean) {
    let printText: any;
    this.translate.get('Print').subscribe((data) => {
      printText = data;
    })
    this.service.getGlobalManagedServicesDetails(this.idsFdspEngineServiceResponseObj.id).subscribe((data) => {
      this.globalManagedRes = data;
      if (!this.globalManagedRes) {
        this.isEnableService = true;
      } else {
        this.isEnableService = false;
      }
      if (this.isEnableService) {
        const req = {
          "createdTimeStamp": createTimeStamp,
          "vin": this.vinNumber,
          "sessionSource": sessionSource
        }
        console.log(req, "request")

        //  this.router.navigateByUrl("/viewVehicleSessions")
        const path = '/viewVehicleSessions' + "?vin=" + this.vinNumber + "&manufacturerId=1&timestamp=" + createTimeStamp + "&sessionSource=" + sessionSource + "&userId=" + this.tokenDetails.username + "&firstName=" + this.tokenDetails.firstName + "&lastName=" + this.tokenDetails.lastName + "&email=" + this.tokenDetails.email + "&dealerCode=" + this.tokenDetails.dealerCode + "&userType=" + this.tokenDetails.userType + "&country=" + this.tokenDetails.country + "&countryThree=" + this.tokenDetails.countryThree + "&language=" + this.tokenDetails.language + "&marketCountry=" + this.tokenDetails.marketCountry + "&year=" + this.vinDetail.modelYear + "&model=" + this.vinDetail.vehicleLineDescription + "&fromCentralStore=" + fromCentralStore + "&token=" + this.tokenDet + "&printText=" + printText + "#nohref";
        window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
      } else {
        this.service.selectedGlobalServices.next('IDS Feedback Service')
        this.router.navigate(['/globalServiceEnabled']);
      }
    });
  }

  openHelp() {
    const path = '/vehicleHelp?language=' + this.tokenDetails.language
    window.open(path, '', 'width=700,innerHeight=700,resizable=yes,scrollbars=yes')
    // var newWindow: any
    // newWindow = window.open("", '_blank', 'resizable=yes,scrollbars=yes,titlebar=yes,width=800,height=900,top=10,left=10')?.document.write
    //   (`<html><head><title>Ford Etis How to Help Page</title><style>h2.title1 {font-size: 10pt;font-weight: bold;text-transform: none;text-indent: 0 mm;margin-top: 2 em;margin-bottom: 0em;margin-left: 5 mm;color: #003F87;}body.localhome {font-weight: none;font-family: Verdana,Tahoma,Arial,Helvetica,Trebuchet,_sans;text-align: Left;text-indent: 0mm;color: black;font-size: 8pt;margin-left: 0 mm;}</style></head><body class="localhome"><center><a onclick="javascript:window.close();" href="#">${this.translatedText[0]}</a>&nbsp&nbsp<a onclick="javascript:window.print();" href="#">${this.translatedText[1]}</a></center><div class="sect"><h2 class="title1">${this.translatedText[2]}</h2><p class="subject">${this.translatedText[3]}</p><p class="subject">${this.translatedText[4]} <b>${this.translatedText[5]}</b> ${this.translatedText[6]}</p><p class="subject">${this.translatedText[4]} <b>${this.translatedText[7]}</b> ${this.translatedText[8]}</p><p class="subject">${this.translatedText[4]} <b>${this.translatedText[9]}</b> ${this.translatedText[10]}</p><p class="subject">${this.translatedText[4]} <b>${this.translatedText[11]}</b> ${this.translatedText[12]}</p><p class="subject">${this.translatedText[4]} <b>${this.translatedText[13]}</b> ${this.translatedText[14]}</p><p class="subject">${this.translatedText[4]} <b>RVC</b> ${this.translatedText[15]}</p><ul><li><b>${this.translatedText[16]}</b> - ${this.translatedText[17]}:-</li><ul class="child"><li><b>RVC(A)</b> - ${this.translatedText[18]}</li><li><b>RVC(H)</b> - ${this.translatedText[19]}</li><li><b>RVC(T)</b> - ${this.translatedText[20]}</li><li><b>${this.translatedText[43]}</b> - ${this.translatedText[21]}</li><li><b>${this.translatedText[44]}</b> - ${this.translatedText[22]}</li></ul><li>${this.translatedText[23]}</li><li>${this.translatedText[24]}</li><li><b>${this.translatedText[25]}</b> - ${this.translatedText[26]}</li><li><b>"${this.translatedText[27]}"</b> - ${this.translatedText[28]}</li><li><b>"${this.translatedText[29]}"</b> - ${this.translatedText[30]}</li><li><b>"${this.translatedText[31]}"</b> - ${this.translatedText[32]}</li><li><b>"${this.translatedText[33]}"</b> - ${this.translatedText[34]}</li></ul><p class="subject">${this.translatedText[4]} <b>${this.translatedText[35]}</b> ${this.translatedText[36]}</p><ul><li><img alt="" src="assets/images/automatic.jpg" border="0"> - ${this.translatedText[37]}</li><li><img alt="" src="assets/images/hotline.jpg" > - ${this.translatedText[38]}</li><li><img alt="" src="assets/images/technician.jpg" > - ${this.translatedText[39]}</li><li><img alt="" src="assets/images/norvc.jpg" > - ${this.translatedText[40]}</li><li><img alt="" src="assets/images/novcm.jpg"> - ${this.translatedText[41]}</li><li><img alt="" src="assets/images/novmm.jpg"> - ${this.translatedText[42]}</li></ul></div><center><a onclick="javascript:window.close();" href="#">${this.translatedText[0]} &nbsp;</a> <a onclick="javascript:window.print();" href="#">${this.translatedText[1]}</a></center></body></html>`);

    // newWindow.document.title="help "
  }

  webPageMapping() {
    this.service.getWebpageMapping().subscribe(data => {
      this.webPages = data;
    })
  }

  checkSnapShotData(sessionId: any) {
    let req = {
      "sessionid": sessionId,
      "fdrsVersion": "unknown",
      "javaVersion": "unknown",
      "firmwareVersioninVCM": "unknown",
      "firmwareVersioninVMM": "unknown",
      "osversion": "unknown",
      "memoryinfo": "unknown",
      "osname": "unknown",
      "cpuinfo": "unknown",
      "deviceserialnumber": "unknown"
    }
    this.service.setSystemSnapShotDetails(req).subscribe((data: any) => {
      console.log('----Resume Session System Snapshot-------', data);
      if (data.fdrsVersion == 'unknown') {
        let snapshotdetails = JSON.parse(localStorage.getItem('systemSnapshot') || '{}')
        if (snapshotdetails.fdrsVersion != 'unknown') {
          this.setSnapShotData(snapshotdetails);
        }
      }
    })
  }

  setSnapShotData(snapshotdetails: any) {
    let req = {
      "sessionid": localStorage.getItem('sessionID'),
      "fdrsVersion": snapshotdetails.fdrsVersion,
      "javaVersion": snapshotdetails.javaVersion,
      "firmwareVersioninVCM": snapshotdetails.vcmVersion,
      "firmwareVersioninVMM": snapshotdetails.vmmVersion,
      "osversion": snapshotdetails.operatingSystemVersion,
      "memoryinfo": snapshotdetails.memoryInfo,
      "osname": snapshotdetails.operatingSystemName,
      "cpuinfo": snapshotdetails.cpuInfo,
      "deviceserialnumber": snapshotdetails.deviceSerialNumber
    }
    this.service.setSystemSnapShotDetails(req).subscribe((data: any) => {
      console.log('----Resume Set Session System Snapshot-------', data);
    })
  }

 resumeSession(session: any, content: any) {
    this.rpcClient.HideFDRSIconIfNotConnected();
    this.service.fromCapture.next(false);

    const req = {
        "vin": this.vinNumber,
        "createdTimeStamp": session.createTimeStamp
    };

    this.service.resumeSession(req).subscribe(data => {
        console.log('-------------resume session API response---------------', data);


         const proceedWithSession = (apiData: any) => {
            console.log("4. Executing proceedWithSession (Loading UI)...");

            // NOW we update the component state
            this.resumeData = apiData;

            this.checkSnapShotData(apiData.sessionId);
            this.service.fromResume.next(true);
            this.service.fromCapture.next(false);
            this.service.navigateSymptom.next('');

            // Update the UI
            this.service.pageData.next(apiData.pageData);

            // Set Storage
            localStorage.setItem("sessionID", apiData.sessionId);
            localStorage.setItem("pageId", apiData.pageId);
             let page = this.webPages[this.resumeData.pageId]
          console.log("page from resume:", page);
          let nextPage = this.pageList[page];
          console.log("nextpage:", nextPage);


          if (page === "rvcWebPage") {
              console.log("Detected rvcWebPage. Navigating to /rvc.");
              localStorage.removeItem('pausedOnRvcPage');
              localStorage.setItem('isRVCINput', 'true');
              this.service.repairQualificationData.next(this.resumeData.pageData);
              console.log('while Resume:::::::::::::',this.resumeData.pageData);
              this.router.navigate([nextPage]);
          }
          else if (page == "customerCommentsWebPage") {
              const modalRef = this.modalService.open(Draggablemodal1Component, {
                  windowClass: "myCustomModalClass"
              });
              modalRef.result.then(
                  result => {
                      console.log(result);
                  },
                  reason => { }
              )
          }
          else if (page == "repairValidationCodeDisplayWebPage") {

              this.service.repairQualificationData.next(this.resumeData.pageData);
              this.service.resumeRVC.next(true);
              this.service.repairQualificationData.subscribe( data =>{
                  this.repairData = data;
              })
              if(this.repairData.rvcCode == 'No RVC' || this.repairData.rvcCode == null || this.repairData.rvcCode == 'No RVC Required' || this.repairData.rvcCode == 'RVC not required') {
                  this.modalService.open(this.noRVCMsgDesc, { size: 'md' })
                  this.disableButtonAfterModalOpen();
              }
              this.service.control.next(false);
              this.service.isRepairProcedure.next(false);
              this.service.isPostRepairProcedure.next(false);
              this.router.navigate(['/repair']);
          }
          else if (page == "repairAndPostRepairEvaluationUserWaitTaskComplete") {
              this.service.repairQualificationData.next(this.resumeData.pageData.repairAndPostRepairDto);
              this.service.resumeRVC.next(false);
              if (this.resumeData.pageData.viewButtonComplete) {
                  this.service.control.next(true);
                  if (this.resumeData.pageData.repairGoComplete) {
                      this.service.isRepairProcedure.next(false);
                      if (!this.resumeData.pageData.postRepairGoComplete) {
                          this.service.isPostRepairProcedure.next(true);
                      } else {
                          this.service.isPostRepairProcedure.next(false);
                      }
                  }
                  else {
                      this.service.isRepairProcedure.next(true);
                      this.service.isPostRepairProcedure.next(false);
                  }
              } else {
                  this.service.control.next(false);
                  this.service.isRepairProcedure.next(false);
                  this.service.isPostRepairProcedure.next(false);
              }
              this.router.navigate(['/repair']);
          }
          else if (page == "purchaseRepairWebPage" || page == "purchasePostRepairWebPage") {
              //navigating to html page else navigate to repair/portrepair procedure
              this.service.repairQualificationData.next(this.resumeData.pageData.repairQualificationPageData);
              if (this.resumeData.pageData.procRefDetails) {
                  let candidateKind: string = this.resumeData.pageData.selectedCandidate.kind;
                  let candidateId: string = this.resumeData.pageData.selectedCandidate.procRef.procUidRef;
                  let gIdArray: any = [];
                  for (let candidate of this.resumeData.pageData.candidates) {
                      if (candidate.kind == 'OTX-CANDIDATE' || candidate.kind == 'OTX-SERVFUNC-CANDIDATE' || candidate.kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
                          if (candidate.result.state == "pass" || candidate.result.state == 'fail') {
                              gIdArray.push(candidate.procRef.procUidRef);
                              candidate.result.state = 'Tested';
                          } else if (candidate.result.state == 'Error') {
                              gIdArray.push(candidate.procRef.procUidRef);
                              candidate.result.state = 'Error';
                          } else if (candidate.result.state == 'abort') {
                              gIdArray.push(candidate.procRef.procUidRef);
                              candidate.result.state = 'Aborted';
                          } else {
                              candidate.result.state = 'Untested';
                          }
                      } else if (candidate.result.state == 'pass') {
                          gIdArray.push(candidate.procRef.procUidRef);
                          candidate.result.state = 'Viewed';
                      } else if (candidate.result.state == 'Error') {
                          gIdArray.push(candidate.procRef.procUidRef);
                          candidate.result.state = 'Error';
                      } else {
                          candidate.result.state = 'Unread';
                      }
                  }
                  if (page == "purchaseRepairWebPage") {
                      let repairObj = {
                          'id': candidateId,
                          'screen': 'repair',
                          'kind': candidateKind
                      }
                      this.service.storeGidRepair.next(gIdArray);
                      this.service.repairObj.next(this.resumeData.pageData.candidates);
                      this.service.navigatetoPreviousScreen.next(repairObj);
                      this.router.navigate(['/repairProcedures']);
                  }
                  else if (page == "purchasePostRepairWebPage") {
                      let postRepairObj = {
                          'id': candidateId,
                          'screen': 'postRepair',
                          'kind': candidateKind
                      }
                      this.service.storeGidPostRepair.next(gIdArray);
                      this.service.postRepairObj.next(this.resumeData.pageData.candidates);
                      this.service.navigatetoPreviousScreen.next(postRepairObj);
                  }

                  if (candidateKind == "PINPOINT-CANDIDATE" || candidateKind == "GENERAL-INFORMATION-CANDIDATE" || candidateKind == "REPAIR-INFO-CANDIDATE") {
                      this.router.navigate(['/view']);
                  }
                  else if (candidateKind == "ETIS-CANDIDATE") {
                      const path = this.ptsUrl + "transport/?link=700&params=" + this.vinNumber + "&uid=" + this.resumeData.pageData.procRefDetails.uid + "&procuid=" + this.resumeData.pageData.procRefDetails.procuid;
                      window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
                      this.router.navigate(['/view']);
                  }
                  else if (candidateKind == "TSB-CANDIDATE") {
                      var procUidref = this.resumeData.pageData.procRefDetails.procuid;
                      procUidref = procUidref.substring(4);
                      procUidref = procUidref.replace("/", "-")
                      if (procUidref == "68-2013") {
                          procUidref = "068-2013"
                      }
                      const path = this.ptsUrl + "Transport?link=001&param=" + procUidref;
                      window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
                      this.router.navigate(['/view'])
                  }
                  else if (candidateKind == "OTX-CANDIDATE" || candidateKind == 'OTX-SERVFUNC-CANDIDATE' || candidateKind == 'OTX_DIAGNOSTIC-CANDIDATE') {
                      if (this.isFDRSConnected) {
                          if (page == "purchaseRepairWebPage") {
                              let selectedRecord = [{
                                  "rating": this.resumeData.pageData.selectedCandidate.rating,
                                  "procedure": this.resumeData.pageData.selectedCandidate.title,
                                  "state": 'Untested'
                              }]
                              this.service.candidateId.next(this.resumeData.pageData.selectedCandidate.procRef.procUidRef);
                              this.service.selectedDiagnosticProcedureData$.next(selectedRecord);
                              this.service.navigatePreviousScreen.next('repairProcedure');
                              this.router.navigate(['/repairProcedures'])
                          }
                          else if (page == "purchasePostRepairWebPage") {
                              let selectedRecord = [{
                                  "rating": this.resumeData.pageData.selectedCandidate.rating,
                                  "procedure": this.resumeData.pageData.selectedCandidate.title,
                                  "state": 'Untested'
                              }]
                              this.service.candidateId.next(this.resumeData.pageData.selectedCandidate.procRef.procUidRef);
                              this.service.selectedDiagnosticProcedureData$.next(selectedRecord);
                              this.service.navigatePreviousScreen.next('postRepairProcedure');
                          }
                          this.router.navigateByUrl('otxCandidate');
                      }
                      else {
                          this.modalService.open(content, { centered: true })
                      }
                  }
              }
              else {
                  let gIdArray: any = [];
                  for (let candidate of this.resumeData.pageData.candidates) {
                      if (candidate.kind == 'OTX-CANDIDATE' || candidate.kind == 'OTX-SERVFUNC-CANDIDATE' || candidate.kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
                          if (candidate.result.state == "pass" || candidate.result.state == 'fail') {
                              gIdArray.push(candidate.procRef.procUidRef);
                              candidate.result.state = 'Tested';
                          } else if (candidate.result.state == 'Error') {
                              gIdArray.push(candidate.procRef.procUidRef);
                              candidate.result.state = 'Error';
                          } else if (candidate.result.state == 'abort') {
                              gIdArray.push(candidate.procRef.procUidRef);
                              candidate.result.state = 'Aborted';
                          } else {
                              candidate.result.state = 'Untested';
                          }
                      } else if (candidate.result.state == 'pass') {
                          gIdArray.push(candidate.procRef.procUidRef);
                          candidate.result.state = 'Viewed';
                      } else if (candidate.result.state == 'Error') {
                          gIdArray.push(candidate.procRef.procUidRef);
                          candidate.result.state = 'Error';
                      } else {
                          candidate.result.state = 'Unread';
                      }
                  }
                  if (page == "repairCandidateSelectionWebPage") {
                      this.service.storeGidRepair.next(gIdArray);
                      this.service.repairObj.next(this.resumeData.pageData.candidates);
                      this.router.navigate(['/repairProcedures']);
                  }
                  else if (page == "postRepairCandidateSelectionWebPage") {
                      this.service.storeGidPostRepair.next(gIdArray);
                      this.service.postRepairObj.next(this.resumeData.pageData.candidates);
                      this.router.navigate(['/postrepairProcedures']);
                  }
              }
          }
          else if (page == "repairCandidateSelectionWebPage" || page == "postRepairCandidateSelectionWebPage") {
              this.service.repairQualificationData.next(this.resumeData.pageData.repairQualificationPageData);
              let gIdArray: any = [];
              for (let candidate of this.resumeData.pageData.candidates) {
                  if (candidate.kind == 'OTX-CANDIDATE' || candidate.kind == 'OTX-SERVFUNC-CANDIDATE' || candidate.kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
                      if (candidate.result.state == "pass" || candidate.result.state == 'fail') {
                          gIdArray.push(candidate.procRef.procUidRef);
                          candidate.result.state = 'Tested';
                      } else if (candidate.result.state == 'Error') {
                          gIdArray.push(candidate.procRef.procUidRef);
                          candidate.result.state = 'Error';
                      } else if (candidate.result.state == 'abort') {
                          gIdArray.push(candidate.procRef.procUidRef);
                          candidate.result.state = 'Aborted';
                      } else {
                          candidate.result.state = 'Untested';
                      }
                  } else if (candidate.result.state == 'pass') {
                      gIdArray.push(candidate.procRef.procUidRef);
                      candidate.result.state = 'Viewed';
                  } else if (candidate.result.state == 'Error') {
                      gIdArray.push(candidate.procRef.procUidRef);
                      candidate.result.state = 'Error';
                  } else {
                      candidate.result.state = 'Unread';
                  }
              }
              if (page == "repairCandidateSelectionWebPage") {
                  this.service.storeGidRepair.next(gIdArray);
                  this.service.repairObj.next(this.resumeData.pageData.candidates);
              }
              else if (page == "postRepairCandidateSelectionWebPage") {
                  this.service.storeGidPostRepair.next(gIdArray);
                  this.service.postRepairObj.next(this.resumeData.pageData.candidates);
              }
              this.router.navigateByUrl(nextPage);
          }
          else if (page == "purchaseDiagnosticWebPage") {
              let candidateData: any;
              candidateData = this.resumeData.pageData.candidates;
              for (let obj of candidateData) {
                  obj.isCheckBoxSelected = false;
                  obj.isCheckBoxDisable = false;
                  if (obj.state == "skipped") {
                      obj.state = 'Skipped';
                      obj.isCheckBoxSelected = true
                      obj.isDisableTestViewBtns = true;
                  } else if (obj.state == "fail") {
                      obj.state = 'fail - Fault found';
                      obj.isCheckBoxDisable = true;
                  } else if (obj.state == 'Error') {
                      obj.state = 'Error';
                      obj.isCheckBoxDisable = true;
                  } else if (obj.state == 'abort') {
                      obj.state = 'Aborted';
                      obj.isCheckBoxDisable = true;
                  } else if (obj.kind == 'OTX-CANDIDATE' || obj.kind == 'OTX-SERVFUNC-CANDIDATE' || obj.kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
                      if (obj.state == "pass") {
                          obj.state = 'Pass - no Fault';
                          obj.isCheckBoxDisable = true;
                      } else {
                          obj.state = 'Untested'
                      }
                  } else if (obj.kind == 'TSB-CANDIDATE' || obj.kind == 'GENERAL-INFORMATION-CANDIDATE'
                      || obj.kind == 'REPAIR-INFO-CANDIDATE' || obj.kind == 'ETIS-CANDIDATE') {
                      if (obj.state == "pass") {
                          obj.state = 'Pass - no Fault';
                          obj.isCheckBoxDisable = true;
                      } else {
                          obj.state = 'Unread'
                      }
                  } else if (obj.kind == 'PINPOINT-CANDIDATE') {
                      if (obj.state == "pass") {
                          obj.state = 'Viewed';
                          obj.isCheckBoxDisable = true;
                      } else {
                          obj.state = 'View';
                      }
                  }
              }
              this.service.getSelectedDiagProcdureId.next(this.resumeData.pageData.selectedCandidate.id);
              this.service.otxStateChangeObj.next(candidateData);
              this.service.fromCapture.next(true)
              this.service.navigateSymptom.next('sym')
              let tempSymptomChildId = [0]
              this.service.candidateId.next(this.resumeData.pageData.selectedCandidate.id);
              this.service.candidateKind.next(this.resumeData.pageData.selectedCandidate.kind);
              this.service.candidateProcUid.next(this.resumeData.pageData.selectedCandidate.procRef.procUidRef);

              if (this.resumeData.pageData.selectedCandidate.kind == "PINPOINT-CANDIDATE"
                  || this.resumeData.pageData.selectedCandidate.kind == "GENERAL-INFORMATION-CANDIDATE"
                  || this.resumeData.pageData.selectedCandidate.kind == "REPAIR-INFO-CANDIDATE") {
                  this.router.navigateByUrl('diagnostic-view');
              }
              else if (this.resumeData.pageData.selectedCandidate.kind == "TSB-CANDIDATE") {
                  var procUidref = this.resumeData.pageData.procRefDetails.procuid;
                  procUidref = procUidref.substring(4);
                  procUidref = procUidref.replace("/", "-")
                  if (procUidref == "68-2013") {
                      procUidref = "068-2013"
                  }
                  const path = this.ptsUrl + "Transport?link=001&param=" + procUidref;
                  window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
                  this.router.navigateByUrl('diagnostic-view')
              }
              else if (this.resumeData.pageData.selectedCandidate.kind == "OTX-CANDIDATE"
                  || this.resumeData.pageData.selectedCandidate.kind == 'OTX-SERVFUNC-CANDIDATE'
                  || this.resumeData.pageData.selectedCandidate.kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
                  if (this.isFDRSConnected) {
                      let selectedRecord = [{
                          "rating": this.resumeData.pageData.selectedCandidate.rating,
                          "procedure": this.resumeData.pageData.selectedCandidate.kind,
                          "state": 'Untested'
                      }]
                      this.service.selectedDiagnosticProcedureData$.next(selectedRecord);
                      this.service.navigatePreviousScreen.next('diagnosticProcedure');
                      this.router.navigateByUrl('otxCandidate');
                  }
                  else {
                      this.modalService.open(content, { centered: true })
                  }
              }
          }
          else if (page == "symptomEvaluationUserWaitTaskComplete" || page == "symptomEvaluationUserWaitTask") {
              this.service.fromCapture.next(true);
              this.service.navigateSymptom.next('sym');
              this.service.diagnosticViewFaultFound.next({
                  "status": '',
                  "isFound": false,
                  "faultString": ''
              });
              this.router.navigateByUrl(nextPage);
          }
          else if (page == "diagnosisSymptomSelectionWebPage") {
              this.service.fromCapture.next(true)
              this.service.navigateSymptom.next('sym')
              let tempSymptomChildId = [0]
              this.service.ParentsymptomSubject.next(this.resumeData.pageData.parentchildsymptomsidList)
              this.service.listsymptomSubject.next(this.resumeData.pageData.symptomidList)
              this.service.symptomSubject.next(this.resumeData.pageData.selectedSymptomCount)
              this.service.tempSymptomSubject.next(tempSymptomChildId)
              this.router.navigateByUrl(nextPage)
          }
          else if (page == "manualDiagnosisInstructionsWebPage") {
              this.service.sId.next(this.resumeData.sessionId)
              this.router.navigateByUrl(nextPage)
          }
          else {
              this.router.navigateByUrl(nextPage);
          }
        };

        // 3. Logic Flow
        if (session.isMobileVehicle) {


            const isSameUser = (session.technicianId === this.tokenDetails.username &&
                                session.dealerCode === this.tokenDetails.dealerCode);

            if (isSameUser) {
                // SCENARIO 1: Same User -> Show Popup
                console.log('Opening Mobile Van Modal...');
                const modalRef = this.modalService.open(this.mobileVanModal, {
  windowClass: 'mobilevan-dialog-window',
  centered: true
});


                modalRef.result.then((keepMobile: boolean) => {
                  if(keepMobile){
                    console.log('Modal Closed. Keep Mobile?', keepMobile);
                     console.log('Modal Closed. Keep Mobile2?', keepMobile);
                    // A. Load UI & Set LocalStorage
                    proceedWithSession(data);

                    // B. Update Backend (Now LocalStorage has ID)
                    this.updateOwnershipCall(session);

                }else{
                   proceedWithSession(data);

                    // B. Update Backend (Now LocalStorage has ID)
                     }
                });
            } else {
                // SCENARIO 2: Different User -> Auto Convert
                console.log('Different user resuming. Converting to standard session.');
                proceedWithSession(data);
                this.updateOwnershipCall(session);
            }
        } else {
            // SCENARIO 3: Standard Session -> Just Load
            console.log('Standard session. Loading immediately.');
            proceedWithSession(data);
        }
      })


  }
  updateOwnershipCall(session: any) {
          const updateReq = {
               "sessionId": String(localStorage.getItem('sessionID')), // Use sessionId from the session object
                "updatedDealerCode": this.tokenDetails.dealerCode,
                "updatedUsername": this.tokenDetails.username,
                "currentUserId": localStorage.getItem("userId"),
                "updatedTimeStamp":new Date().toISOString(),
                "isMobileVehicle": false,
                "alreadyResumedByDealer": true // Send as string or boolean depending on backend DTO
                        };
                        this.service.updateDealerCode(updateReq).subscribe({
                            next: (res) => {
                                console.log('Dealer code updated successfully');
                            },
                            error: (err) => {
                                console.error('Failed to update dealer code', err);
                            }
                        });
                      }

  sessionData: any
  disableButtonAfterModalOpen() {
    setTimeout(() => {
      this.isButtonEnabled = false;
    }, 3000);
  }
  filter() {
    let req: any = {
      "vin": this.vinNumber,
      "userid": this.userId,
      "pageNumber": 0,  /*this.q1 - 1,*/
      "pageSize": 20,
      "sessionSource": this.sessionSource
    }
    console.log(this.q1, 'filter q1');
    this.getVehicleSessions(req, true, true);

    // this.service.getVehicleSessionsV1(req).subscribe((datas) => {
    //   this.sessionData = datas.idssessionList;
    //   // this.sessionData = this.sessionData.filter((data:any) => datas.includes(source)
    //   console.log(this.sessionSource, "this.sessionSource")
    //   if (this.sessionSource != "ALL") {
    //     var data: any = []
    //     // for(let i of this.sessionData.sbdoLocalSessionList ){
    //     //   if(i.sessionSource == this.sessionSource){
    //     //     data.push(i)
    //     //   }
    //     // }
    //     var idsData: any = []
    //     for (let i of this.sessionData) {
    //       if (i.sessionSource == this.sessionSource) {
    //         idsData.push(i)
    //       }
    //     }
    //   }
    //   else {
    //     // var data: any =  this.sessionData.sbdoLocalSessionList;
    //     var idsData: any = this.sessionData;
    //   }
    //   // for (let i of data) {
    //   //   let date = new Date(i.createTimeStamp)
    //   //   let dateDisplay: any = (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear().toString().substr(2, 2);
    //   //   var time = date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
    //   //   i.time = time
    //   //   i.date = dateDisplay
    //   //   let value = this.stateList[i.workflowSessionState]
    //   //   i.state = this.state[value]
    //   // }
    //   // this.serviceList = data
    //   for (let i of idsData) {
    //     let date = new Date(i.createTimeStamp)
    //     let dateDisplay: any = (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear().toString().substr(2, 2);
    //     var time = date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
    //     i.time = time
    //     i.date = dateDisplay
    //     //let value=this.stateList[i.workflowSessionState]
    //     console.log('-------------------work flow state', this.state[i.workflowSessionState]);
    //     if(this.state[i.workflowSessionState] != undefined){
    //       i.state = this.translate.instant(this.state[i.workflowSessionState])
    //     }
    //   }
    //   this.centralList = idsData;
    //   if (this.centralList == null || this.centralList == undefined || this.centralList == "") {
    //     this.noCentralData = true
    //   }
    //   else {
    //     this.noCentralData = false
    //   }
    //   // this.indcount = this.serviceList.length
    //   this.indcount1 = this.centralList.length
    //   // console.log(this.serviceList, "service list")
    //   console.log(this.centralList, "centralList")

    //   for (let i of this.centralList) {
    //     this.rvcCode = ""
    //     if (i.rvcCode != null) {
    //       this.rvcCode = i.rvcCode;
    //     }

    //     if (i.indictmentMethod != null) {
    //       if (i.indictmentMethod == "manualTechnician") {
    //         if (i.rvcCode == "RVC=0") {
    //           this.rvcCode = "";
    //           if (i.finisCode == "1111111") {
    //             this.rvcCode = "Labor"
    //           }
    //           else if (i.finisCode == "9999999") {
    //             this.rvcCode = "Major assembly"
    //           }
    //         }
    //       }
    //     }
    //     i.rvcCodeNew = this.rvcCode;
    //   }
    // })
  }
downloadPageAsPdf(): void {
  const element: HTMLElement = document.body;

  const opt: any = {
    margin: [12, 12, 12, 12],        // 12mm margins
    filename: 'Page-Report.pdf',
    image: { type: 'jpeg', quality: 0.95 },
    html2canvas: { scale: 1.25, useCORS: true },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  };

  // html2pdf loaded via CDN
  // @ts-ignore
  if (typeof html2pdf !== 'undefined') {
    // @ts-ignore
    html2pdf().from(element).set(opt).save();
  } else {
    window.print();
  }
}

printPageNative(): void {
  window.print();
}

toggleDropdown(e: Event) {
  const btn = e.target as HTMLElement;
  const menu = btn.parentElement!.querySelector('#actionsMenu') as HTMLElement;
  menu.style.display = (menu.style.display === 'block') ? 'none' : 'block';
}




}
